const homeSections = document.getElementsByClassName('home__section')

if (homeSections.length > 0) {
    const height = window.innerHeight

    const newsGroup = document.getElementsByClassName('news-list-story')
    const pageGroup = document.getElementsByClassName('page-previews__item')
    const comingEventsGroup = document.getElementsByClassName('upcoming-events__item homepage2')
console.log(comingEventsGroup.length)
    const nav = document.getElementsByClassName('nav')[0]

    // add animations for each section appearing
    window.addEventListener('scroll', () => {
        Array.from(homeSections).map((section, key) => {
            const pageTop = section.getBoundingClientRect().top

            if (pageTop < height / 4 * 3 + 80)
                if (!section.classList.contains('active')) {
                    section.classList.add('active')
                    switch (key) {
                    // latest news
                    case 1:
                        for (let i = 0; i < newsGroup.length; i++)
                            setTimeout(function () {
                                newsGroup[i].classList.add('active')
                            }, 100 * i)

                        break
                        // page previews
                    case 2:
                        for (let i = 0; i < pageGroup.length; i++)
                            setTimeout(function () {
                                pageGroup[i].classList.add('active')
                            }, 100 * i)

                        break
                        // upcoming events
                    case 3:
                        for (let i = 0; i < comingEventsGroup.length; i++)
                            setTimeout(function () {
                                comingEventsGroup[i].classList.add('active')
                            }, 100 * i)

                        break

                    }
                }
        })

        // shrink nav height with scroll if on Andover site
        if (
            !document.body.classList.contains('home') &&
            nav.dataset.collapsible === 'true' &&
            homeSections.length > 1
        )
            if (homeSections[0].getBoundingClientRect().top * 3 + height > 0)
                return nav.classList.contains('content')
                    ? nav.classList.remove('content')
                    : ''
            else
                return nav.classList.contains('content')
                    ? ''
                    : nav.classList.add('content')
    })
}
